import ConfirmModal from "kustom-front/src/components/molecules/ConfirmModal";
import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import "./style.scss";

interface Props {
  display: boolean;
  onDismiss: () => void;
  onRemove: () => void;
}

const CartRemoveProductModal: FunctionComponent<Props> = ({ display, onDismiss, onRemove }) => {
  const intl = useIntl();

  return (
    <ConfirmModal
      confirmLabel={intl.formatMessage({ id: "cheerz_CartRemoveProductModal_delete" })}
      dismissLabel={intl.formatMessage({ id: "cheerz_CartRemoveProductModal_cancel" })}
      display={display}
      onConfirm={onRemove}
      onDismiss={onDismiss}
    >
      <div className="CartRemoveProductModal">
        <div className="CartRemoveProductModal-content">
          <div className="CartRemoveProductModal-image" />
          <div className="CartRemoveProductModal-title">
            {intl.formatMessage({
              id: "cheerz_CartRemoveProductModal_title",
            })}
          </div>
          <div className="CartRemoveProductModal-description">
            {intl.formatMessage({
              id: "cheerz_CartRemoveProductModal_description",
            })}
          </div>
        </div>
      </div>
    </ConfirmModal>
  );
};

export default CartRemoveProductModal;
